export function getLinkToHubletOrGridPage({
  ckey,
  shouldShowGridPage,
  summaryGroup,
  detailKeyForProcess,
  workScheduleForProcess,
}: {
  ckey: string;
  shouldShowGridPage: boolean;
  summaryGroup: string;
  detailKeyForProcess: string;
  workScheduleForProcess?: string;
}) {
  return {
    pathname: `/${ckey}/${
      shouldShowGridPage ? "grid" : "dashboard"
    }/${summaryGroup}/${detailKeyForProcess}`,
    search: `workSchedule=${workScheduleForProcess}`,
    state: {
      shouldNotGoToCurrentShift: true,
    },
  };
}

export const VERY_LONG_NAME_LENGTH = 11;
